import { FC, useEffect, useState } from "react";
import { useSelector } from "../../../hooks";
import { formatNumberWithSpaces } from "../../../utils/numbers";
import styles from "./DrawsTopBlock.module.scss";
import { DrawMemberStatus, DrawMethod } from "../DrawItem";
import { trueDrawsForm, truePlayersForm } from "../../../utils/true.word.form";
import { Highlightable } from "../../../components/Highlight/Highlightable";
import { ActionPromptType } from "../../../hooks/prompts";
import { now } from "../../../utils/time";
import { DrawContext } from "../DrawRoutes";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../components/Menu/MenuButton";

interface IDrawsTopBlockProps {
    positionHandler: () => void;
    method: DrawMethod;
}

export const DrawsTopBlock: FC<IDrawsTopBlockProps> = ({ positionHandler, method }) => {
    const [available, setAvailable] = useState(0);

    const navigate = useNavigate();
    const { items, stat } = useSelector(store => store.draws);

    useEffect(() => {
        if (!items)
            return;

        const count = items
            .filter(item => method === item.method)
            .reduce((acc, draw) => {
                if (draw.userStatus === DrawMemberStatus.None && draw.operDate > now())
                    ++acc;
                return acc;
            }, 0);
        setAvailable(count);
    }, [items, method]);

    const onWinnersClickHandler = () => navigate(`/${AppContext.Draw}/${DrawContext.Winners}`);

    return (
        <div className={styles.giftBlock}>
            { stat &&
                <div className={styles.giftInfoItem} onClick={ onWinnersClickHandler }>
                    <span>{ formatNumberWithSpaces(stat.winnersCount) }</span> {truePlayersForm(stat.winnersCount)} уже<br />
                    получили <span>{formatNumberWithSpaces(stat.rewardTotal)}</span>{" "}руб
                </div>
            }

            { items &&
                <Highlightable promptType={ActionPromptType.DRAWS_ADD} highlightClass={styles.highlight} >
                    <div className={styles.giftInfoItem} onClick={ positionHandler }>
                        Доступно <span>{available}</span> из <span>{items.filter(item => method === item.method).length}</span><br />
                        {" "} {trueDrawsForm(items.length)}
                    </div>
                </Highlightable>
            }
        </div>
    );
}